export const ROLES = {
    CUSTOMER: 'customer',
    ADMIN: 'admin',
    SUPERADMIN: 'superadmin',
};
export const BOOKING_STATUS = {
    HOLD: 'HOLD',
    TICKETING: 'TICKETING',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED',
    EXPIRED: 'EXPIRED',
};
export const FLIGHT_STATUS = {
    SCHEDULED: 'SCHEDULED',
    BOARDING: 'BOARDING',
    DEPARTED: 'DEPARTED',
    ARRIVED: 'ARRIVED',
    CANCELLED: 'CANCELLED',
    DELAYED: 'DELAYED',
};
export const SEAT_CLASS = {
    ECONOMY: 'economy',
    PREMIUM_ECONOMY: 'premium_economy',
    BUSINESS: 'business',
    FIRST: 'first',
};
/** Cabin values accepted by the API, in display order (economy → first). */
export const SEAT_CLASS_VALUES = [
    SEAT_CLASS.ECONOMY,
    SEAT_CLASS.PREMIUM_ECONOMY,
    SEAT_CLASS.BUSINESS,
    SEAT_CLASS.FIRST,
];
export const PAYMENT_STATUS = {
    PENDING: 'PENDING',
    REDIRECTED: 'REDIRECTED',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
    REFUNDED: 'REFUNDED',
    REFUND_PENDING: 'REFUND_PENDING',
};
export const PAYMENT_GATEWAY = {
    MOCK: 'MOCK',
    SAMAN: 'SAMAN',
};
export const MILEAGE_TIER = {
    BLUE: 'BLUE',
    SILVER: 'SILVER',
    GOLD: 'GOLD',
    PLATINUM: 'PLATINUM',
};
export const MILEAGE_TIER_THRESHOLDS = {
    BLUE: 0,
    SILVER: 25000,
    GOLD: 50000,
    PLATINUM: 100000,
};
export const MILEAGE_CLASS_MULTIPLIER = {
    economy: 1,
    premium_economy: 1.25,
    business: 1.5,
    first: 2,
};
export const BOOKING_HOLD_MINUTES = 15;
export const AUDIT_ACTIONS = {
    LOGIN: 'LOGIN',
    LOGIN_FAILED: 'LOGIN_FAILED',
    LOGOUT: 'LOGOUT',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    PAYMENT: 'PAYMENT',
    RECONCILE: 'RECONCILE',
};
//# sourceMappingURL=constants.js.map